<template>
    <div class="card card-custom gutter-b">
        <div class="card-header border-0 py-8">
            <div class="card-title align-items-start flex-column">
                <h3 class="card-label font-weight-bolder text-dark mb-3">
                    {{ notification.title }}
                </h3>
                <div class="d-flex align-items-center font-size-sm text-muted">
                    <div class="symbol symbol-40 symbol-light mr-3 flex-shrink-0">
                        <span class="symbol-label">
                            <i :class="notificationIcon(notification.type)" class="text-white text-lg"></i>
                        </span>
                    </div>

                    <div class="d-flex align-items-center">
                        <svg v-if="notification.seen_at" width="18" height="18" viewBox="0 0 256 256" class="ml-2">
                            <path
                                d="M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Z"
                                fill="#4F46E5" opacity="0.7" />
                            <path
                                d="M245.71,74.39a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"
                                fill="#4F46E5" />
                        </svg>

                        <i v-else class="far fa-clock ml-2 text-muted"></i>

                        <span
                            :class="{ 'text-primary font-weight-bold': notification.seen_at, 'text-muted': !notification.seen_at }">
                            {{ formatDate(notification.created_at) }}
                        </span>

                        <span v-if="!notification.seen_at" class="label label-sm label-primary label-rounded ml-3 px-4">
                            جدید
                        </span>
                    </div>
                </div>
            </div>

            <div class="card-toolbar">
                <router-link to="/notifications" class="btn btn-light-primary font-weight-bold px-6">
                    <i class="flaticon2-left-arrow-1"></i>
                    بازگشت به لیست
                </router-link>
            </div>
        </div>

        <div class="card-body pt-6">
            <div class="bg-light rounded p-8 mb-8">
                <p class="font-size-lg text-dark-75 leading-relaxed" v-html="notification.message"></p>
            </div>

            <div class="text-muted font-size-sm">
                شناسه اعلان: #{{ notification.id }}
                <span class="mx-2">•</span>
                نوع: <span class="font-weight-bold" :class="typeTextClass(notification.type)">{{
                    typeLabel(notification.type) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
    name: "NotificationShow",

    data() {
        return {
            notification: {}
        };
    },

    mounted() {
        this.fetchNotification();
    },
    watch: {
        '$route.params.id'(newId, oldId) {
            if (newId !== oldId) {
                this.fetchNotification();
            }
        }
    },
    methods: {
        fetchNotification() {
            ApiService.get(`notifications/${this.$route.params.id}`)
                .then(({ data }) => {
                    this.notification = data.data || data;

                    if (!this.notification.seen_at) {
                        this.$set(this.notification, 'seen_at', new Date().toISOString());
                    }
                })
                .catch(() => {
                    this.$toast.error("اعلان یافت نشد");
                    this.$router.push("/notifications");
                });
        },

        formatDate(date) {
            return new Date(date).toLocaleString("fa-IR", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        },

        notificationIcon(type) {
            const icons = {
                success: "flaticon2-check-mark text-success",
                info: "flaticon2-information text-info",
                warning: "flaticon2-warning text-warning",
                error: "flaticon2-delete text-danger",
                message: "flaticon2-chat-1 text-primary"
            };
            return icons[type] || "flaticon2-bell text-primary";
        },

        typeLabel(type) {
            const labels = {
                success: "موفقیت",
                info: "اطلاع‌رسانی",
                warning: "هشدار",
                error: "خطا",
                message: "پیام مستقیم"
            };
            return labels[type] || "نامشخص";
        },

        typeTextClass(type) {
            const classes = {
                success: "text-success",
                info: "text-info",
                warning: "text-warning",
                error: "text-danger",
                message: "text-primary"
            };
            return classes[type] || "text-muted";
        }
    }
};
</script>

<style scoped>
.leading-relaxed {
    line-height: 2;
}

.label-primary {
    background-color: #4F46E5 !important;
    color: white;
}
</style>